import 'jquery';
import { fromEvent } from "rxjs";
import Siema from 'siema';
import WaitHandler from '../../../handlers/wait-handler';
import CartHelper from '../../../helpers/cart-helper';
import { BrowserCommunicatorService } from '../../../services/browser-communicator-service';
import StoreService from "../../../services/store-service";
import ShoppingCartHandlers from "../../../shared/shopping-cart/handlers/shopping-cart-handlers";
import ShoppingCartService from '../../../shared/shopping-cart/services/shopping-cart-service';
import { $applicationMonitoringService } from '../../application-monitoring';
import { DynamicKitHandlers } from "../../dynamic-kits/handlers/dynamic-kit-handlers";
import AddProductToListEvent from "../../favorite-list/events/add-product-to-list-event";
import AddedProductFavoriteListEvent from "../../favorite-list/events/added-product-favorite-list-event";
import { HandlerBase } from "../../handler/handler-base";
import { ProductAnalyticsHelper } from "../../helper/product-analytics-helper";
import AddedPredictiveSearchEvent from "../../shopping-cart/events/added-predictive-search-event";
import EmptyCartEvent from "../../shopping-cart/events/empty-cart-event";
import LessProductEvent from "../../shopping-cart/events/less-product-event";
import MoreProductEvent from "../../shopping-cart/events/more-product-event";
import RemoveProductEvent from "../../shopping-cart/events/remove-product-event";
import SetQuantityProductEvent from "../../shopping-cart/events/set-quantity-product-event";
import UpdateProductEvent from "../../shopping-cart/events/update-product-event";
import AddedProductDetailEvent from "../events/added-product-detail-event";
import { AnalyticsMetaHelper } from '../../helper/analytics-meta-helper';
import { analytics } from 'apollo-web';

export class ProductCardHandlers extends HandlerBase {

    /** @returns {boolean} */
    get _isFullMode() {
        return $("#FullMode").val() === "True"
    }

    /** @returns {boolean} */
    get _dispatchShoppingCartEvents() {
        return !this._isFullMode;
    }

    /** @type {[]} */
    _eventsSubs = []

    /** @type {[]} */
    _cartEventsSub = []

    //#region constructors

    constructor() {
        super()

        this._shoppingCartService = new ShoppingCartService(this._getJourneyArea())
        this._storeService = new StoreService(false)
        this._browserCommunicatorService = new BrowserCommunicatorService()
        this._shoppingCartHandlers = new ShoppingCartHandlers()
        this._dynamicKitHandlers = new DynamicKitHandlers();
        this._productAnalyticsHelper = new ProductAnalyticsHelper();
        this.addSiemaMethods()
    }

    //#endregion

    //#region bindings

    init() {
        this.bindShoppinCartControl();
        this.bindProduct();
        this._dynamicKitHandlers.init();
        this.bindShoppingCartEvents();
        this.dispatchAnalyticsEvents();
    }

    dispatchAnalyticsEvents() {
        new Promise(async () => {
            const service = await $applicationMonitoringService;
            const analyticsData = AnalyticsMetaHelper.getAnalyticsDataFromMeta();
            service.trackViewItem({
                currency: analyticsData.currency,
                value: parseFloat(analyticsData.product_price) || 0,
                items: this.generateViewItems()
            })
        }).then(_ => {})
    }

    /**
     * 
     * @returns {[]}
     */
    generateViewItems() {
        const productElement = document.querySelector('.product-id-contaniner');
        const dataAttributes = {};

        Array.from(productElement.attributes).forEach(attr => {
            if (attr.name.startsWith('data-product')) {
                const attributeName = attr.name.substring(13); // Remueve 'data-product' del nombre
                dataAttributes[attributeName] = attr.value; // Guarda el valor del atributo
            }
        });

        const itemId = productElement.getAttribute("data-product-id") || analytics.AnalyticsConstants.DefaultParameterValue;
        const itemName = productElement.getAttribute("data-product-name") || analytics.AnalyticsConstants.DefaultParameterValue;
        const discount = parseFloat(dataAttributes.discount) || 0;
        const itemBrand = dataAttributes.brand || analytics.AnalyticsConstants.DefaultParameterValue;
        const itemFabricante = dataAttributes.manufacturername || analytics.AnalyticsConstants.DefaultParameterValue;
        const itemCategory = dataAttributes.departmentname || analytics.AnalyticsConstants.DefaultParameterValue;
        const itemCategory2 = dataAttributes.productcategory || analytics.AnalyticsConstants.DefaultParameterValue;
        const itemCategory3 = dataAttributes.productgroup || analytics.AnalyticsConstants.DefaultParameterValue;
        const price = parseFloat(dataAttributes.price) || 0;
        const quantity = parseInt(dataAttributes.stock) || 0;
        const coupon = dataAttributes.coupon || analytics.AnalyticsConstants.DefaultParameterValue;

        const viewItem = {
            item_id: itemId,
            item_name: itemName,
            coupon: coupon,
            discount: discount,
            index: 1,
            item_brand: itemBrand,
            item_fabricante: itemFabricante,
            item_category: itemCategory,
            item_category2: itemCategory2,
            item_category3: itemCategory3,
            price: price,
            quantity: quantity,
        };

        return [viewItem];
    }

    /**
     * Bind ShoppingCart events
     * - Less products
     * - More products
     * - Set quantity products
     * - remove product
     * - empty cart
     */
    bindShoppingCartEvents() {
        this._cartEventsSub.push(
            MoreProductEvent.$.subscribe((args) => {
                this.updateProductQuantity(args.productBranchOfficeId, args.shoppingCartResponse)
            }),

            LessProductEvent.$.subscribe((args) => {
                this.updateProductQuantity(args.productBranchOfficeId, args.shoppingCartResponse)
            }),

            SetQuantityProductEvent.$.subscribe((args) => {
                this.updateProductQuantity(args.productBranchOfficeId, args.shoppingCartResponse)
            }),

            RemoveProductEvent.$.subscribe(args => {
                this.updateProductQuantity(args.productBranchOfficeId, args.shoppingCartResponse);
            }),

            EmptyCartEvent.$.subscribe(_ => {
                this.toggleQuantityBtn($(".btn-group"));
            }),

            AddedProductFavoriteListEvent.event$.subscribe(args => {
                this.updateProductQuantityFromEvent(args);
            }),

            AddedPredictiveSearchEvent.event$.subscribe(args => {
                this.updateProductQuantityFromEvent(args);
            })
        )
    }

    updateProductQuantityFromEvent(args) {
        const productId = args.productBranchOfficeId;
        const quantity = args.shoppingCartItemChanged.ProductQuantity;
        const cardElement = $(`div.product-card-detail[data-product-id="${productId}"]`);

        this.toggleQuantityBtn(cardElement.find(".add-to-cart"));
        cardElement.find(".quantity_display").html(quantity);
        this.bindProductControls(productId);
    }

    async bindProduct() {

        const productId = $(".product-id-contaniner").data('product');
        const internalId = $(".product-id-container").data("internal-id")
        const loadingtarget = ".product-card-detail"
        this._loading(true, loadingtarget)
        try {
            const itemResponse = await this._shoppingCartService.getItemFetch(productId)
            if (!itemResponse.ok) {
                this.handleErrorCartResponseAsync(itemResponse)
                return;
            }
            const responseJson = await itemResponse.json()
            const shoppingCartItem = responseJson.Value
            if (shoppingCartItem && shoppingCartItem.Quantity > 0) {
                $(".quantity_display").text(shoppingCartItem.Quantity);
                this.toggleQuantityBtn($('.add-to-cart-detail'));
                this.bindProductControls(productId)
            }

            this.unBindEvents();
            const addToCartButton = document.querySelector(".add-to-cart-detail");
            if (addToCartButton) {
                this._eventsSubs.push(
                    fromEvent(document.querySelector(".add-to-cart-detail"), "click",).subscribe(async e => {
                        await this.addToCartProductDetail(e, productId);
                    })
                )
            }
            this.initImageControls()

        } catch (e) {
            console.error(e)
            await this._browserCommunicatorService.displayErrorAlert({
                description: `Ocurrió un error al cargar la información del producto, por favor intente nuevamente.`
            })
        } finally {
            this._loading(false)
        }

        // dispatch "view_item" analytic event.
        this.trackProductDetail();

        WaitHandler.startWaiting(7000);
    }

    /**
     * Track product detail analytics event
     * */
    trackProductDetail() {
        try {
            const productId = (document.querySelector("div.product-id-contaniner")).getAttribute("data-product")
            const productSource = document.querySelector("#analyticsIdentifier")?.value || 'Catalog';

            this._productAnalyticsHelper.trackDetail(productSource, productId)
                .then(_ => { });
        } catch (e) {
            console.error(e);
        }
    }

    bindProductControls(productId) {
        $(".quantity_add").off("click")
        $(".quantity_add").on("click", { 'productId': productId }, e => this.moreProductDetail(e))

        $(".quantity_remove").off("click")
        $(".quantity_remove").on("click", { 'productId': productId }, e => this.lessProductDetail(e))

        $(".quantity_display").off()
        $(".quantity_display").on("click", { 'productId': productId }, e => this.switchToInputDetail(e))
    }

    initImageControls() {

        //init siema carousel and zoom
        var product = $('.product-card-detail');
        var imageSliderWrapper = product.find('.product-detail__image')
        if (imageSliderWrapper.children().length > 1) {
            const imageSlider = new Siema({
                selector: imageSliderWrapper[0],
                draggable: false,
                loop: false,
                onChange: this.onImageSlideChange,
                onInit: this.onImageSlideInit
            });

            // Trigger pagination creator
            imageSlider.addPagination();

            product.find('.product-detail__button-prev').click(() => {
                imageSlider.prev()
            });
            product.find('.product-detail__button-next').click((e) => {
                imageSlider.next()
            });
        }

        $('.product-image').parent().zoom({
            magnify: 1,
            onZoomIn: this._onZoomInHandler
        });
    }

    bindShoppinCartControl() {
        $('.add-product-to-favorite-list').off('click');
        $('.add-product-to-favorite-list').on('click', e => this._addToFavoritesList(e));

        $('#buttonReturn').off('click');
        $('#buttonReturn').on('click', this._returnTo.bind(this));
    }

    //#endregion

    //#region methods

    /**
     * 
     * @param event {JQuery.ClickEvent}
     * */
    async moreProductDetail(event) {

        event.stopPropagation();
        const buttonsTarget = ".product-card-detail"
        this._loading(true, buttonsTarget)

        try {
            let productId = event.data.productId;

            const shoppingCartResponse = await this._shoppingCartService.increaseProductQuantityFetch(productId)

            if (!shoppingCartResponse.ok) {
                this.handleErrorCartResponseAsync(shoppingCartResponse)
                return
            }

            const value = await shoppingCartResponse.json();
            if (!value.Successful) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: value.UserMessage
                })
                return;
            }

            const shoppingCartResponseJson = value.Value
            if (!shoppingCartResponseJson.Successed) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: shoppingCartResponseJson.Message,
                    html: true
                })
                return;
            }
            else if (shoppingCartResponseJson.Message) {
                await this._browserCommunicatorService.displayInfoAlert({
                    description: shoppingCartResponseJson.Message,
                    html: true
                })
            }

            this._dispatchUpdateProductEvent("more", productId, shoppingCartResponseJson, true)
            this.updateProductQuantity(productId, shoppingCartResponseJson);
            
        } catch (e) {
            console.error(e)
            await this._browserCommunicatorService.displayErrorAlert({ description: e.message })
        } finally {
            this._loading(false, buttonsTarget)
        }
    }

    /**
     * 
     * @param event {JQuery.ClickEvent}
     * */
    async lessProductDetail(event) {
        event.stopPropagation();

        let productId = event.data.productId;
        const loadingtarget = ".product-card-detail"
        this._loading(true, loadingtarget)

        try {
            const decreaseResponse = await this._shoppingCartService.decreaseProductQuantityFetch(productId)
            if (!decreaseResponse.ok) {
                await this.handleErrorCartResponseAsync(decreaseResponse)
                return;
            }

            const value = await decreaseResponse.json();
            if (!value.Successful) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: value.UserMessage
                })
                return;
            }

            const shoppingCartItemChangedResponse = value.Value
            if (!shoppingCartItemChangedResponse.Successed) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
                return;
            }
            else if (shoppingCartItemChangedResponse.Message) {
                await this._browserCommunicatorService.displayInfoAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
            }

            this._dispatchUpdateProductEvent("less", productId, shoppingCartItemChangedResponse);
            this.updateProductQuantity(productId, shoppingCartItemChangedResponse);

        } catch (e) {
            console.error(e)
            await this._browserCommunicatorService.displayErrorAlert({ description: e.message })
        } finally {
            this._loading(false, loadingtarget)
        }
    }

    /**
     * 
     * @param event {Event}
     * */
    async addToCartProductDetail(event, productId) {
        event.stopPropagation();
        const loadingTarget = ".product-card-detail"
        this._loading(true, loadingTarget)
        try {
            const element = $(event.currentTarget)
            var imgtodrag = element.closest('.product-card-detail').find(".product-image").eq(0);
            CartHelper.sendProductImageToCar(imgtodrag);

            const addResponse = await this._shoppingCartService.addItemAsync(1, productId, false)
            if (!addResponse.ok) {
                await this.handleErrorCartResponseAsync(addResponse)
                return;
            }

            const value = await addResponse.json();
            if (!value.Successful) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description : value.UserMessage
                })
                return;
            }

            const shoppingCartItemChangedResponse = value.Value;
            if (!shoppingCartItemChangedResponse.Successed) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
                return;
            }
            else if (shoppingCartItemChangedResponse.Message) {
                await this._browserCommunicatorService.displayInfoAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
            }

            AddedProductDetailEvent.added({
                productId: productId,
                shoppingCartItemChanged: shoppingCartItemChangedResponse
            });
            
            this.toggleQuantityBtn(element);
            $('.quantity_display').html('1');
            this.bindProductControls(productId)

        } catch (e) {
            await this._browserCommunicatorService.displayErrorAlert({ description: e.message })
            console.error(e)
        } finally {
            this._loading(false, loadingTarget)
        }

        // dispatch "add to cart" analytics event.
        this._productAnalyticsHelper.trackAddToCart(productId)
            .then(_ => { });
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} shoppingCartItemChangedResponse 
     */
    updateProductQuantity(productId, shoppingCartItemChangedResponse) {
        const cardElement = $(`div.product-card-detail[data-product-id="${productId}"]`)
        let newQuantity = shoppingCartItemChangedResponse.ProductQuantity;
        if (newQuantity <= 0) {
            this.toggleQuantityBtn(cardElement.find(".btn-group"));
        }

        let productQuantityElement = cardElement.find('.quantity_display');
        productQuantityElement.html(newQuantity);
    }

    /**
     * 
     * @param button {JQuery<HTMLElement>}
     * */
    toggleQuantityBtn(button) {
        button.hide();
        button.siblings().show();
    }

    /**
     * 
     * @param event {JQuery.ClickEvent}
     * */
    switchToInputDetail(event) {
        const element = $(event.currentTarget)
        var $input = $("<input>", {
            val: element.text(),
            type: "number",
            min: 1
        });
        $input.addClass("quantity_display-input");
        element.replaceWith($input);
        $input.on("blur", { ...event.data },this.switchToSpanDetail.bind(this));
        $input.select();
    }

    /**
     * 
     * */
    _loading(loading, target = ".product-card-detail") {
        kendo.ui.progress($(target), loading)
    }

    /**
    * 
    * @param {Response | XMLHttpRequest} response
    */
    async handleErrorCartResponseAsync(response) {
        if (response.status === 401) {
            await this._browserCommunicatorService.displayErrorAlert({ description: "No esta autorizado para realizar esta acción" })
        }

        if (response.status === 400) {
            console.debug(await response.json())
            await this._browserCommunicatorService.displayErrorAlert({
                description: "Occurrieron errores de validación, por favor intente nuevamente"
            })
            this.init()
        }

        var spinnerWait = $(this).closest('.product-card').find(".spinner-border-sm").eq(0);
        spinnerWait.addClass("d-none");
    }

    displayEmptyCart() {
        this._shoppingCartHandlers.displayEmptyCart();
    }

    /**
     * 
     * @param e {JQuery.ClickEvent}
     * */
    _addToFavoritesList(e) {

        const element = $(e.currentTarget);
        const productId = element.data("productid");

        AddProductToListEvent.add({ 
            productId: productId
        })   
    }

    onImageSlideChange() {
        // dispatch "product_image" analytics event
        const productContainerEl = document.querySelector("div.product-id-contaniner");
        let productName = productContainerEl.getAttribute("data-product")
        let imageEl = document.querySelector(`img.product-image[data-number="${this.currentSlide + 1}"]`)

        const productAnalyticsHelper = new ProductAnalyticsHelper();
        productAnalyticsHelper.trackImage(productName)
            .then(_ => { });

        let totalZeroBased = this.innerElements.length - 1;
        let current = this.currentSlide;
        switch (current) {
            case 0:
                $('.product-detail__button-prev').hide();
                $('.product-detail__button-next').show();
                break;
            case totalZeroBased:
                $('.product-detail__button-prev').show();
                $('.product-detail__button-next').hide();
                break;
            default:
                $('.product-detail__button-prev').show();
                $('.product-detail__button-next').show();
                break;
        }
        $('.product-detail__image>button').removeClass('selected');
        $('.product-detail__image>button:nth-of-type(' + (current + 1) + ')').addClass('selected');
    }

    onImageSlideInit() {
        $('.product-detail__button-prev').hide();
    }

    addSiemaMethods() {
        Siema.prototype.addPagination = function () {
            if (this.innerElements.length > 1) {
                for (let i = 0; i < this.innerElements.length; i++) {
                    const btn = document.createElement('button');
                    btn.setAttribute("type", "button")
                    //btn.textContent = i;
                    if (i == this.currentSlide) {
                        var name, arr;
                        name = "selected";
                        arr = btn.className.split(" ");
                        if (arr.indexOf(name) == -1) {
                            btn.className += " " + name;
                        }
                    }
                    btn.addEventListener('click', () => this.goTo(i));
                    this.selector.appendChild(btn);
                }
            }
        }

        // override siesa resize handler to prevent button removal
        Siema.prototype.resizeHandler = function () {
            // update perPage number dependable of user value
            this.resolveSlidesNumber();

            // relcalculate currentSlide
            // prevent hiding items when browser width increases
            if (this.currentSlide + this.perPage > this.innerElements.length) {
                this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage;
            }

            this.selectorWidth = this.selector.offsetWidth;

            this.buildSliderFrame();
            this.addPagination();
        }
    }

    /**
    * Handled when you zoom in image of a product
    * */
    _onZoomInHandler() { }

    /**
     * 
     * @param e {JQuery.BlurEvent}
     * */
    async switchToSpanDetail(e) {
        const element = $(e.currentTarget)
        var $span = $("<span>", {
            text: element.val()
        });
        $span.addClass("button button--secondary-reverse quantity_display");
        element.replaceWith($span);
        $span.on("click", { ...e.data }, e => this.switchToInputDetail(e));
        await this.addProductDetail($span, e.data.productId);
    }

    /**
     * 
     * @param span {JQuery<HTMLElement>}
     * */
    async addProductDetail(span, productId) {
        
        const quantity = span[0].innerText;
        const loadingtarget = ".product-card-detail"
        this._loading(true, loadingtarget)

        try {
            const addProductResponse = await this._shoppingCartService.addProductQuantityFetch(productId, quantity)
            if (!addProductResponse.ok) {
                this.handleErrorCartResponseAsync(addProductResponse)
                return;
            }

            const value = await addProductResponse.json();
            if (!value.Successful) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: value.UserMessage
                })
                return;
            }

            const shoppingCartItemChangedResponse = value.Value
            if (!shoppingCartItemChangedResponse.Successed) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
                return;
            }
            else if (shoppingCartItemChangedResponse.Message) {
                await this._browserCommunicatorService.displayInfoAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
            }

            this._dispatchUpdateProductEvent("setQuantity", productId, shoppingCartItemChangedResponse)
            this.updateProductQuantity(productId, shoppingCartItemChangedResponse);

        } catch (e) {
            console.error(e)
        } finally {
            this._loading(false, loadingtarget)
        }
    }

    _returnTo() {
        window.history.back();
    }

    /**
     * 
     * @param {"more" | "less" | "setQuantity" } action
     * @param {string} productId
     * @param {{}} shoppingCartResponseJson
     * @param {boolean} dispatchEvent
     */
    _dispatchUpdateProductEvent(action, productId, shoppingCartResponseJson) {
        UpdateProductEvent.update({
            productBranchOfficeId: productId,
            shoppingCartResponse: shoppingCartResponseJson,
            options: {
                action: action,
                dispatchEvent: this._dispatchShoppingCartEvents
            }
        })
    }

    unBindEvents() {
        this._eventsSubs.forEach(sub => {
            sub?.unsubscribe()
        })
        this._eventsSubs = [];
    }

    unBindCartEvents() {
        this._cartEventsSub.forEach(sub => {
            sub?.unsubscribe();
        })
        this._cartEventsSub = []
    }

    //#endregion

}